const IMAGES_FOLDER = 'img/'
const COUPON_IMAGES_FOLDER = 'img/coupon/'
const PROMOTION_FILE = 'promozioni.json'
const SALONE_IMAGES_FILE = 'immagini_salone.json'
const SERVICES_FILE = "services.json"



export default {
    IMAGES_FOLDER: IMAGES_FOLDER,
    PROMOTION_FILE: PROMOTION_FILE,
    SALONE_IMAGES_FILE: SALONE_IMAGES_FILE,
    SERVICES_FILE: SERVICES_FILE
}
